import { render } from "./AddedToBasket.vue?vue&type=template&id=781153ce"
import script from "./AddedToBasket.vue?vue&type=script&lang=js"
export * from "./AddedToBasket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__